var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeMachineAttract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1856,
    height: 2608,
    viewBox: "0 0 1856 2608",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M2928.66 1327.33V2212.65C2610.02 2212.65 2350.65 2472.02 2350.65 2790.66H1465.33C1465.33 1983.63 2121.63 1327.33 2928.66 1327.33ZM1465.33 749.315V-136C658.304 -136 2 520.304 2 1327.33H887.315C887.315 1008.69 1146.69 749.315 1465.33 749.315ZM2 2790.66H887.315C887.315 2472.02 1146.69 2212.65 1465.33 2212.65V1327.7C658.304 1327.7 2 1984 2 2791.03V2790.66ZM1465.33 1327.33H2350.65C2350.65 1008.69 2610.02 749.315 2928.66 749.315V-136C2121.63 -136 1465.33 520.304 1465.33 1327.33Z",
    stroke: "#F5EDAE",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeMachineAttract);
export default __webpack_public_path__ + "static/media/time-machine-attract.5a7f8482021183a423d903b0226a7028.svg";
export { ForwardRef as ReactComponent };